import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Autorizacao from '../../security/Autorizacao';
import { PERFIL_ADMIN } from '../../security/securityContext';
import Titulo from '../comum/Titulo';
import selecionarAdesaoPonto from '../../actions/adesao-pontos/selecionarAdesaoPonto';

export class MenuAdesaoPontos extends Component {

    render() {
        return (
            <div className="container-padrao">
                <Titulo texto="Adesão de Pontos" urlRetorno="/gestao" />
                <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}
                    empresaSelecionada={this.props.empresaSelecionada}>
                    <div className="vx-menu-grid">
                        <Link
                            to="/painel-cadastro-configuracao-ponto"
                            onClick={() => this.props.selecionarAdesaoPonto(null)}
                            className="vx-menu-card">
                            <div className="vx-menu-card-icon">
                                <i className="material-icons">add_circle_outline</i>
                            </div>
                            <span className="vx-menu-card-label">Nova Configuração</span>
                        </Link>
                        <Link to="/painel-gerenciar-adesao-pontos" className="vx-menu-card">
                            <div className="vx-menu-card-icon">
                                <i className="material-icons">supervisor_account</i>
                            </div>
                            <span className="vx-menu-card-label">Gestão de Pontos</span>
                        </Link>
                    </div>
                </Autorizacao>
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        empresaSelecionada: state.empresaSelecionada,
        authentication: state.authentication,
    };
}

export default withRouter(connect(mapStateToProps, {
    selecionarAdesaoPonto,
})(MenuAdesaoPontos));
